import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import ModelsOverview from "@/pages/ModelsOverview";
import ModelDetail from "@/pages/ModelDetail";
import Gallery from "@/pages/Gallery";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import { MODELS } from "@/data/content";

function App() {
  useEffect(() => {
    document.documentElement.lang = "sr-Latn";
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/modeli-kontejnera" element={<ModelsOverview />} />

            {MODELS.map((model) => (
              <Route
                key={model.slug}
                path={`/${model.slug}`}
                element={<ModelDetail slug={model.slug} />}
              />
            ))}

            <Route path="/galerija" element={<Gallery />} />
            <Route path="/o-nama" element={<About />} />
            <Route path="/kontakt" element={<Contact />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;